import { LocalStorage } from "./storage";
import Validator from "./validator";
import Formatter from "./formatter";

var _sessionUser = {};
var _initialState = {};

const _KEY_USER = "uid";
const _KEY_INITIAL_STATE = "sid";

class SessionUser {
  static _savePersistentSession(key, data) {
    LocalStorage.storeSecured(key, data);
  }

  static _loadFromPersistentSession(key) {
    return LocalStorage.getSecured(key);
  }

  static _updateUserInfo(user) {
    _sessionUser = Formatter.merge({
      name: user.name || "",
      email: user.email || "",
      phone: user.phone || "",
      points: user.points || 0,
      role: user.role || "",
      avatar: user.avatar || "",
      token: user.token || "",
      lastLogin: user.lastLogin || "",
    });

    this._savePersistentSession(_KEY_USER, _sessionUser);
  }

  static _saveInitialStateInfo(state) {
    this._savePersistentSession(_KEY_INITIAL_STATE, state);
  }

  static _getInitialStateInfo() {
    if (Validator.isEmpty(_initialState)) {
      _initialState = this._loadFromPersistentSession(_KEY_INITIAL_STATE) || {};
    }

    return _initialState;
  }

  static _clearInitialStateInfo() {
    _initialState = {};
    LocalStorage.removeItem(_KEY_INITIAL_STATE);
  }

  static _getUserInfo() {
    if (Validator.isEmpty(_sessionUser)) {
      _sessionUser = this._loadFromPersistentSession(_KEY_USER) || {};
    }

    return _sessionUser;
  }

  static _clearUserInfo() {
    _sessionUser = {};
    LocalStorage.removeItem(_KEY_USER);
  }
}

export default SessionUser;



// WEBPACK FOOTER //
// ./src/helpers/session-user.js